import script from "./soft-load-img.vue?vue&type=script&setup=true&lang=js"
export * from "./soft-load-img.vue?vue&type=script&setup=true&lang=js"

import "./soft-load-img.vue?vue&type=style&index=0&id=7e5feda2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e5feda2"]])

export default __exports__